import React, { useState, useEffect } from "react";
import axios from "axios";
import Cookies from "universal-cookie";
import Modal from "react-modal";

// 🔥 IMPORTANTE (solo una vez en tu app, idealmente en index.js)
Modal.setAppElement("#root");

function ResumenOmModal({ institucionId }) {
  const cookies = new Cookies();

  const [open, setOpen] = useState(false);
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(false);

  const id = institucionId || cookies.get("institucionid");

  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);

  useEffect(() => {
    if (!open || !id) return;

    const fetchData = async () => {
      setLoading(true);
      try {
        const res = await axios.get(
          `https://suadesarrollo.azurewebsites.net/api/TablaOPModel/${id}`,
          {
            auth: {
              username: "BasicAuth@icontec.org",
              password: "yQLzqmR7eZSuAmQZUqhY",
            },
          },
        );

        setData(res.data);
      } catch (error) {
        console.error("Error:", error);
        setData({});
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, [open, id]);

  return (
    <>
      {/* BOTÓN */}
      <button className="btn btn-primary" onClick={handleOpen}>
        Resumen OM
      </button>

      {/* MODAL */}
      <Modal
        isOpen={open}
        onRequestClose={handleClose}
        contentLabel="Resumen OM"
        style={{
          overlay: {
            backgroundColor: "rgba(0, 0, 0, 0.5)",
            zIndex: 9999,
          },
          content: {
            top: "50%",
            left: "50%",
            right: "auto",
            bottom: "auto",
            transform: "translate(-50%, -50%)",
            width: "80%",
            maxWidth: "900px",
            borderRadius: "10px",
            padding: "20px",
          },
        }}
      >
        {/* HEADER */}
        <h5>Resumen OM</h5>

        {/* BODY */}
        {loading ? (
          <p>Cargando...</p>
        ) : (
          <div className="table-responsive">
            <table className="table table-bordered">
              <thead>
                <tr>
                  <th>Total oportunidades</th>
                  <th>Total agrupadas</th>
                  <th>Total solucionadas</th>
                  <th>Total parciales</th>
                  <th>Total reiteradas</th>
                  <th>Total nuevas</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td>{data?.totalOportunidades ?? 0}</td>
                  <td>{data?.totalAgrupapas ?? 0}</td>
                  <td>{data?.totalSolucionadas ?? 0}</td>
                  <td>{data?.totalParciales ?? 0}</td>
                  <td>{data?.totalReiteradas ?? 0}</td>
                  <td>{data?.totalNuevas ?? 0}</td>
                </tr>
              </tbody>
            </table>
          </div>
        )}

        {/* FOOTER */}
        <div style={{ textAlign: "right", marginTop: "20px" }}>
          <button className="btn btn-secondary" onClick={handleClose}>
            Cerrar
          </button>
        </div>
      </Modal>
    </>
  );
}

export default ResumenOmModal;
